var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.715 7.1025C17.505 6.6575 17.9008 6.435 18.1166 6.07583C18.3333 5.7175 18.3333 5.285 18.3333 4.42V3.845C18.3333 2.74 18.3333 2.18667 17.9666 1.84333C17.6016 1.5 17.0125 1.5 15.8333 1.5H4.16663C2.98829 1.5 2.39913 1.5 2.03329 1.84333C1.66746 2.18667 1.66663 2.74 1.66663 3.84583V4.42083C1.66663 5.285 1.66663 5.7175 1.88329 6.07583C2.09996 6.43417 2.49413 6.6575 3.28496 7.1025L5.71246 8.46917C6.24246 8.7675 6.50829 8.91667 6.69829 9.08167C7.09329 9.42417 7.33663 9.8275 7.44663 10.3233C7.49996 10.56 7.49996 10.8383 7.49996 11.3942V13.6192C7.49996 14.3767 7.49996 14.7558 7.70996 15.0508C7.91996 15.3467 8.29329 15.4925 9.03829 15.7842C10.6041 16.3958 11.3866 16.7017 11.9433 16.3533C12.5 16.005 12.5 15.21 12.5 13.6183V11.3933C12.5 10.8383 12.5 10.56 12.5533 10.3225C12.6579 9.8368 12.9216 9.39987 13.3025 9.08083",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.5629a9c26bb67113e45d82a5916e2e52.svg";
export { ForwardRef as ReactComponent };